var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import { PickerOption, } from '../Picker';
import { AttributeIcon, } from './AttributeIcon';
const optionContainerStyles = css `
  width: fit-content;
`;
const AttributeIconPickerOption = (_a) => {
    var { iconType } = _a, pickerOptionProps = __rest(_a, ["iconType"]);
    return (_jsx("div", Object.assign({ css: optionContainerStyles }, { children: _jsx(PickerOption, Object.assign({}, pickerOptionProps, { children: iconType === 'external'
                ? (_jsx(AttributeIcon, { iconType: "external", path: 'path' in pickerOptionProps ? pickerOptionProps.path : '' }))
                : (_jsx(AttributeIcon, { iconType: iconType })) })) })));
};
const MemoizedAttributeIconPickerOption = memo(AttributeIconPickerOption);
export { MemoizedAttributeIconPickerOption as AttributeIconPickerOption };
// MC-1068 Temporary hack for Storybook.
export default AttributeIconPickerOption;
